/* ==========================================================================
   Dida - Selleasy skočni prozor: prijevod natpisa i označavanje gumba

   ZAŠTO JS, A NE CSS:
   Prvi pokušaj je mijenjao tekst preko ::after uz font-size: 0. Klase te
   aplikacije ponavljaju se na više ugniježđenih elemenata (host > cont >
   button), pa se isti natpis ispisivao dva ili tri puta jedan preko drugoga.
   Ovdje se tekst mijenja točno jednom, na elementu koji ga stvarno sadrži,
   i dodaje se vlastita klasa da CSS ima jednoznačnu metu.

   Ne dira ništa izvan .lb-popup-cont.
   ========================================================================== */

(function () {
  'use strict';

  var PRIJEVODI = [
    ['Add items to cart', 'Dodaj u košaricu'],
    ['Add item to cart', 'Dodaj u košaricu'],
    ['Skip this offer', 'Ne, hvala'],
    ['No thanks', 'Ne, hvala'],
    ['Often bought together', 'Uzmi još i uštedi!'],
    ['Frequently bought together', 'Uzmi još i uštedi!'],
    ['Često kupljeno zajedno', 'Uzmi još i uštedi!'],
    ['Take more and save', 'Uzmi još i uštedi!'],
    ['Select a product', 'Odaberite proizvod'],
    ['Select product', 'Odaberite proizvod'],
  ];

  function prevediJednom(korijen) {
    // Samo tekstualni čvorovi: tako se mijenja točno jedan element,
    // onaj koji tekst doista sadrži, bez diranja roditelja.
    var hodac = document.createTreeWalker(korijen, NodeFilter.SHOW_TEXT, null);
    var cvor;
    while ((cvor = hodac.nextNode())) {
      var t = cvor.nodeValue.trim();
      if (!t) continue;
      for (var i = 0; i < PRIJEVODI.length; i++) {
        if (t.toLowerCase() === PRIJEVODI[i][0].toLowerCase()) {
          cvor.nodeValue = cvor.nodeValue.replace(t, PRIJEVODI[i][1]);
          break;
        }
      }
    }
  }

  function oznaciGumbe(korijen) {
    var gumbi = korijen.querySelectorAll('button, [role="button"]');
    for (var i = 0; i < gumbi.length; i++) {
      var g = gumbi[i];
      // preskoči omotače: obilježava se samo element koji ima vlastiti tekst
      if (!g.textContent || !g.textContent.trim()) continue;
      if (g.querySelector('button')) continue;

      var t = g.textContent.trim().toLowerCase();
      if (t.indexOf('ne, hvala') === 0 || t.indexOf('skip') === 0) {
        g.classList.add('dida-up-sporedni');
      } else if (
        t.indexOf('dodaj u košaricu') === 0 ||
        t.indexOf('add item') === 0 ||
        t.indexOf('odaberite proizvod') === 0 ||
        t.indexOf('select') === 0
      ) {
        g.classList.add('dida-up-glavni');
      }
    }
  }

  function obradi() {
    var p = document.querySelector('.lb-popup-cont');
    if (!p) return;
    prevediJednom(p);
    oznaciGumbe(p);
  }

  // Namjerno setTimeout, a NE requestAnimationFrame: rAF se u kartici koja
  // nije u prvom planu ne izvršava, pa se popup ne bi preveo dok korisnik
  // ne vrati prozor. setTimeout radi uvijek.
  var zakazano = false;
  var promatrac = new MutationObserver(function () {
    if (zakazano) return;
    zakazano = true;
    setTimeout(function () {
      zakazano = false;
      obradi();
    }, 0);
  });

  function pokreni() {
    promatrac.observe(document.body, { childList: true, subtree: true });
    obradi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pokreni);
  } else {
    pokreni();
  }
})();
